import { useEffect, useState } from "react";
import moment from "moment/moment";
import { Tooltip } from "@mui/material";
import { masterApi } from "../../apis/masterApi";
import info from "../../assets/svgs/info.svg";

const TOOLTIP_TEXT =
  "The displayed time is based on your system's time zone, and there might be a data discrepancy of up to 45 minutes";

export default function DataLastUpdated() {
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const [lastfetched, setLastfetched] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function getCursorData() {
      const cursor = await masterApi(
        {
          cursor_purpose: "AMAZON_STATS_HOURLY",
          source: "amazon",
        },
        "cursor",
        false
      );
      if (cancelled) return;

      const cursorData = (cursor?.data?.data ?? []).filter(
        (item) => item.last_fetch_status === "SUCCESS"
      );
      const dataPulledDate = cursorData[0]?.data_pulled_date;
      if (dataPulledDate) {
        setLastfetched(
          moment.utc(dataPulledDate).local().format("Do MMM YYYY, h:mm a")
        );
      }
    }

    getCursorData();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!lastfetched || userPlatform !== "amazon") return null;

  return (
    <Tooltip title={TOOLTIP_TEXT} placement="top" arrow>
      <span className="text-muted text-small" style={{ cursor: "default" }}>
        <small>
          Data last updated at {lastfetched}{" "}
          <img src={info} alt="" />
        </small>
      </span>
    </Tooltip>
  );
}
